export var getTrueKey = function (key) {
    if (key === void 0) { key = ''; }
    var arr = key.split('_');
    if (arr.length === 3) {
        return arr[2];
    }
    else if (arr.length > 3) {
        return arr.splice(2).join('_');
    }
    else {
        return key;
    }
};
export var fixEntityObj = function (it) {
    if (!it)
        return it;
    var obj = {};
    Object.keys(it).forEach(function (key) {
        var tKey = getTrueKey(key);
        obj[tKey] = it[key];
    });
    return obj;
};
